export const WebSocketUpdateMessage = {
   MessageCreated :'message.created',
   StatusChanged :'conversation.status_changed',
   conversationtyping_off :'conversation.typing_off',
   conversationtyping_on :'conversation.typing_on'
}

export const SenderType = {
    Contact :'User',
    Bot :'Bot',
    LiveAgent:"LiveAgent"
}

export enum Status {
    Failure = "Failure",
    Success = "Success",
    Duplicate = "Duplicate",
    Unauthorized = "Unauthorized",
}

export const SupportQus = {
    "1" : "Filing with IRS/SSA",
    "2" : "Knowing Filing Status",
    "3" : "Handling Bulk Upload",
    "4" : "Accessing Recipient Copies"
}

export const WidgetList = {
    Home: "Home",
    AIChatBot: "AIChatBot",
    Help: "Help",
    News: "News",
    ChatHistory: "ChatHistory",
    UserLogin: "UserLogin"
}

export const PartnerName = {
    Sage : 'Sage'
}